import { asSingleStyleConfig } from '../../../../utils/theme';
export var baseStyle = {
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: "all 0.15s ease-out",
    cursor: 'pointer',
    textDecoration: 'none',
    letterSpacing: '0',
    outline: 'none',
    color: 'blue.275',
    fontWeight: 'semibold',
    _hover: {
      textDecoration: 'underline'
    },
    _focus: {
      boxShadow: 'none',
      outline: 'none',
      bg: 'blue.1140',
      textDecoration: 'underline'
    }
  },
  leftIcon: {
    width: '1.25rem',
    marginRight: '.875rem',
    display: 'inline-flex',
    alignItems: 'center'
  },
  rightIcon: {
    width: '1.25rem',
    marginLeft: '.875rem',
    display: 'inline-flex',
    alignItems: 'center'
  }
};
export var Link = asSingleStyleConfig({
  baseStyle
});